module.exports = __webpack_public_path__ + "img/New PACI Flow - New-3.aeffefc5.png";